export class NotificationModel {
  userId: string;
  clientId: number;
  email: string;
  password: string;
  siteUrl: string = "";
  contractorId: string  = "";
  departmentId: string  = "";
  employeeId: string  = "";
  emailFor: string  = ""
}

